// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/hotel/hotel_booking.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_entity_place } from "../../entity/place_pb";
import { file_proto_model_feature_hotel_hotel_offer } from "../../feature/hotel/hotel_offer_pb";
import { file_proto_model_feature_hotel_hotel_preferences } from "../../feature/hotel/hotel_preferences_pb";
import { file_proto_model_booking_hotel_guest_info } from "./guest_info_pb";
import { file_proto_model_booking_shared_provider_booking_details } from "../shared/provider_booking_details_pb";
import { file_proto_model_financial_budget } from "../../financial/budget_pb";

/**
 * Describes the file proto/model/booking/hotel/hotel_booking.proto.
 */
export const file_proto_model_booking_hotel_hotel_booking = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9ib29raW5nL2hvdGVsL2hvdGVsX2Jvb2tpbmcucHJvdG8SBmNhcm1lbiK0AgoMSG90ZWxCb29raW5nEhwKBWhvdGVsGAEgASgLMg0uY2FybWVuLlBsYWNlEiUKCnJvb21fb2ZmZXIYAiABKAsyES5jYXJtZW4uUm9vbU9mZmVyEiEKBmd1ZXN0cxgDIAMoCzIRLmNhcm1lbi5HdWVzdEluZm8SGAoQc3BlY2lhbF9yZXF1ZXN0cxgEIAMoCRItCgtwcmVmZXJlbmNlcxgFIAEoCzIYLmNhcm1lbi5Ib3RlbFByZWZlcmVuY2VzEjgKEHByb3ZpZGVyX2RldGFpbHMYBiABKAsyHi5jYXJtZW4uUHJvdmlkZXJCb29raW5nRGV0YWlscxI5ChFidWRnZXRfdmFsaWRhdGlvbhgHIAEoCzIeLmNhcm1lbi5CdWRnZXRWYWxpZGF0aW9uUmVzdWx0QjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw", [file_proto_model_entity_place, file_proto_model_feature_hotel_hotel_offer, file_proto_model_feature_hotel_hotel_preferences, file_proto_model_booking_hotel_guest_info, file_proto_model_booking_shared_provider_booking_details, file_proto_model_financial_budget]);

/**
 * Describes the message carmen.HotelBooking.
 * Use `create(HotelBookingSchema)` to create a new message.
 */
export const HotelBookingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_hotel_hotel_booking, 0);

